import { NgModule, Component, OnInit, ViewChild, Input } from '@angular/core';
import { EventRead } from '../shared/event-read.model';
import { EventCopy } from '../shared/event-copy.model';
import { EventsService } from '../shared/events.service';
import { UtilService, DialogService, NotificationService, TranslationService } from '../../shared/index';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { UserService } from '../../users/shared/user.service';

@Component({
  selector: 'wl-copy-event',
  templateUrl: 'event-copy.component.html',
  providers: [EventsService, UserService],
    standalone: false
})
export class EventCopyComponent implements OnInit {
  @Input('eventId') eventid: number;
  @Input('event') event: EventRead;
  public eventCopy: EventCopy;
  public userAccessLevel: number;
  public showModal = false;

  public constructor(
    public _eventsService: EventsService,
    public _dialogService: DialogService,
    public _userService: UserService,
    public _navigationService: NavigationService
  ) {
    this.eventCopy = new EventCopy(0);

    this.userAccessLevel = 0;
  }

  ngOnInit() {
    this._userService.getCurrentUserSecurityElementAccessLevel('Events_Module').then((data: number) => {
      this.userAccessLevel = data;
    });
  }

  /**
   * handles copy button click
   */
  public dulplicateClick(): void {
    this.showModal = true;

    if (this.event) {
      this.eventCopy = new EventCopy(this.event.EventId);
      this.eventCopy.NewStartDate = this.event.StartDate;
    } else {
      this.eventCopy = new EventCopy(0);
    }
  }

  public cancelClick = (): void => {
    this.showModal = false;
  };

  public copyEvent = (): void => {
    this.showModal = false;
    this._dialogService.showWaitIndicator();
    this._eventsService.copyEvent(this.event.EventId, this.eventCopy).then(
      newEventId => {
        this._dialogService.closeWaitIndicator();
        this._navigationService.navigateToEvent(newEventId);
      },
      (error: any) => {
        this._dialogService.closeWaitIndicator();
        this._dialogService.error(error);
      }
    );
  };
}
